//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: 'MetalButtonGroup',
  props: {
    control: {required: true},
    data: {required: true},
    product: {required: true},
    stonePositions: {required: false},
  },
  data() {
    return {
      title: this.control.label,
      firstLoad: true,
    }
  },
  computed:{
    ...mapGetters('frontend/productDetail',['getIsLoadingImage'])
  },
  methods: {
    getMetalNameCSS(metalColor) {
      const color = metalColor.includes(' ')
        ? metalColor.split(' ')[0]
        : metalColor
      return `${color}-metal-name-background-color`
    },
    onMetalChange(v) {
      if (this.firstLoad) {
        v = parseInt(
          this.product.FormData.MA[Object.keys(this.product.FormData.MA)[0]]
            .SecondValue
        )
        this.firstLoad = false
      }
      const metal = this.control.MetalTypes[v]
      this.disableUnavailableMetals(metal, false)
      this.$emit('updateValue', {
        controlType: this.control.type,
        controlName: this.control.name,
        value: metal,
        secondValue: v,
        summary: this.getSummary(v),
      })
    },
    getSummary(selectedValue) {
      let summary = ''
      for (const groupKey in this.control.GroupedOptions) {
        const group = this.control.GroupedOptions[groupKey]
        for (const optionKey in group.Options) {
          const option = group.Options[optionKey]
          if (option.id === selectedValue) {
            summary = `${
              !group.Key.toLowerCase().includes('silver')
                ? `${option.value.substring(0, option.value.length - 1)} `
                : ''
            }${group.Key.replace(/sterling/gi, '').trim()}`
          }
        }
      }
      return summary
    },
    disableUnavailableMetals(currentMetalColorInFirstSelector, firstLoad) {
      if (!currentMetalColorInFirstSelector) {
        return
      }

      const Product = this.product
      if (
        Product.Controls.filter((c) => {
          return c.type === this.control.type
        }).length > 1 &&
        this.control.name === Object.keys(this.data.MA)[0]
      ) {
        let firstEnabledOptionValue = null
        const otherMetalSelectors = Product.Controls.filter((c) => {
          return c.type === this.control.type && c.name !== this.control.name
        })
        for (const iControl in otherMetalSelectors) {
          const otherMetalSelectorComponent = this.$parent.$refs[
            `${otherMetalSelectors[iControl].type}_${otherMetalSelectors[iControl].name}`
          ]

          const metalVariants =
            otherMetalSelectorComponent &&
            otherMetalSelectorComponent[0].stonePositions &&
            otherMetalSelectorComponent[0].stonePositions.MetalVariants
              ? otherMetalSelectorComponent[0].stonePositions.MetalVariants[
                    currentMetalColorInFirstSelector === "SLV" ? currentMetalColorInFirstSelector : currentMetalColorInFirstSelector.slice(-1)
                ]
              : 'WYR'


          for (const iGroupedOption in otherMetalSelectors[iControl].GroupedOptions) {
            for (const iOption in otherMetalSelectors[iControl].GroupedOptions[iGroupedOption].Options) {
              const currentOption =
                otherMetalSelectors[iControl].GroupedOptions[iGroupedOption]
                  .Options[iOption]

                currentOption.Disabled =

                  metalVariants.includes(currentOption.value.slice(-1)) === false
                if (
                  !firstEnabledOptionValue &&
                  metalVariants.length > 1 &&
                  currentOption.Disabled === false &&
                  metalVariants.slice(0, 1) === currentOption.value.slice(-1)
                ) {
                  firstEnabledOptionValue = currentOption.value
                }
            }
          }
        }

        if (firstLoad == false) {
          for (const iMetal in this.data.MA) {
            if (iMetal != Object.keys(this.data.MA)[0]) {
              const value = !firstEnabledOptionValue
                ? currentMetalColorInFirstSelector
                : firstEnabledOptionValue
              const secondValue = Object.keys(this.control.MetalTypes).find(
                (key) =>
                  this.control.MetalTypes[key] === this.data.MA[iMetal].Value
              )
              this.$emit('updateValue', {
                controlType: this.control.type,
                controlName: iMetal,
                value,
                secondValue,
              })
            }
          }
        }
      }
    },
    getTitle(name) {
      let title = this.control.label
      const Product = this.product
      if (
        Product.Controls.filter((c) => c.type == 'metalButtonGroup').length > 1
      ) {
        title =
          Product.Controls.filter((c) => c.type == 'metalButtonGroup')[0]
            .name == name
            ? 'Select shank metal'
            : 'Select top metal'
      }
      return title
    },
  },
}
